import Vue from 'vue'
//import VueAnalytics from 'vue-ua'
import Router from 'vue-router'
import Wrapper from '@/components/Wrapper'
import WrapperRT from '@/components/WrapperRT'
import WrapperCTA from '@/components/WrapperCTA'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/:email/:source',
      name: 'WrapperSource',
      component: Wrapper
    },
    {
      path: '/:email',
      name: 'Wrapper',
      component: Wrapper
    },
    {
      path: '/',
      name: 'WrapperHome',
      component: Wrapper
    },
    {
      path: '/hbsp/:vid/rt',
      name: 'WrapperRT',
      component: WrapperRT
    },
    {
      path: '/cta/:email/collect',
      name: 'WrapperCTA',
      component: WrapperCTA
    },
  ]
})

/*Vue.use(VueAnalytics, {
  appName: 'recrutement.rivalab.com', // Mandatory
  appVersion: '1.0', // Mandatory
  trackingId: 'UA-515574-13', // Mandatory
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackPage: false // Whether you want page changes to be recorded as pageviews (website) or screenviews (app), default: false
})*/

export default router
